/**
 * Normalize Quill disclaimer HTML before render.
 * Admin saves ql-indent-* classes; data-list is sometimes stripped in storage.
 */
export function normalizeDisclaimerHtml(html) {
  if (!html || typeof document === "undefined") {
    return html || "";
  }

  const template = document.createElement("template");
  template.innerHTML = html;

  template.content.querySelectorAll("ol").forEach((ol) => {
    const items = ol.querySelectorAll(":scope > li");
    const hasIndent = Array.from(items).some((li) =>
      Array.from(li.classList).some((cls) => cls.startsWith("ql-indent-"))
    );

    if (!hasIndent && !ol.querySelector("li[data-list]")) {
      return;
    }

    ol.classList.add("disclaimer-quill-list");

    items.forEach((li) => {
      const indentClass = Array.from(li.classList).find((cls) =>
        cls.startsWith("ql-indent-")
      );

      if (indentClass && !li.getAttribute("data-list")) {
        li.setAttribute("data-list", "ordered");
      }

      if (!li.getAttribute("data-list") && !indentClass) {
        li.setAttribute("data-list", "ordered");
      }

      li.style.paddingLeft = "";
      li.style.marginLeft = "";
    });
  });

  template.content.querySelectorAll("ul").forEach((ul) => {
    ul.querySelectorAll(":scope > li").forEach((li) => {
      if (!li.getAttribute("data-list")) {
        li.setAttribute("data-list", "bullet");
      }
    });
  });

  return template.innerHTML;
}
